import { FunctionComponent as F } from "react";
import UpdateIcon from '@mui/icons-material/Update';
import TextTooltip from "../Tooltip/TextTooltip";
import { useNavigate } from "react-router-dom";
import { NEW_PRICE } from "../../../core/router/paths";


interface IProps
{
  listingId: number,
  size?: number
}

const UpdatePrice: F<IProps> = (props: IProps) =>
{
  const navigate = useNavigate();

  return(
    <TextTooltip lines={["Attempt price update"]} tooltipPlacement='bottom-start'>
      <UpdateIcon
        fontSize='small'
        sx={{ height: props.size || 17, color: 'lightGray', cursor: 'pointer' }}
        onClick={() => navigate(props.listingId + "/" + NEW_PRICE, { relative: 'path' })}/>
    </TextTooltip>);
};

export default UpdatePrice;
